(function () {
  function boot() {
    var root = document.querySelector(".hfb-081");
    if (!root || root.getAttribute("data-hfb-081") === "1") return;
    root.setAttribute("data-hfb-081", "1");
    var scroller = root.querySelector(".hfb-081__reviews");
    var dots = root.querySelectorAll(".hfb-081__dots button");
    if (!scroller || !dots.length) return;
    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        var card = scroller.children[index];
        if (card) card.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
    });
    scroller.addEventListener("scroll", function () {
      var cards = scroller.children;
      var mid = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var center = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var dist = Math.abs(center - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      dots.forEach(function (dot, index) {
        dot.classList.toggle("is-on", index === best);
      });
    }, { passive: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
